module.exports = __webpack_public_path__ + "media/images/webpage/shared/sale/cover-640x360-a4f83cf92c8f644f7504a27a911fa7f1.webp";